import { isMobileOnly, isTablet } from 'mobile-device-detect'

export default {
  data() {
    return {
      windowWidth: 1140
    }
  },
  beforeMount() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
      this.windowWidth = window.innerWidth
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    isMobile() {
      return this.windowWidth < 601 || isMobileOnly
    },
    isTablet() {
      return (this.windowWidth < 1140) || isTablet
    }
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
